<template>
  <el-autocomplete
    v-model="innerValue"
  :fetch-suggestions="getKeyWords"
  value-key="name"
  placeholder="请输入客户名称"
  @select="handleSelect"
  @clear="clearData"
  clearable
  >
  <template slot-scope="{item}" >
    <div style="border-bottom: 1px solid #ccc; line-height:1.5;padding: 4px 0;">
      客户ID：{{item.id}}<br />
      客户姓名：{{item.name}}（{{item.credentials_code}}）<br />
      所属项目：{{item.project_name}}<br />
      相关房产：
      <el-popover
        placement="top-start"
        title=""
        width="400"
        trigger="hover">
        <template slot="default">
          <div style="max-height: 500px; overflow-y: scroll;">
              <span v-for="(item2,idx) in item.house_list" :key="idx">
                {{item2.ancestor_name}}({{item2.status_name}})<br />
              </span>
          </div>
        </template>
        <el-link type="primary" slot="reference">
          {{item.house_list.length}} 个房产
        </el-link>
      </el-popover>
      <br />
    </div>
  </template>
  </el-autocomplete>
</template>

<script>
import Http from "../../common/Http";

export default {
  name: "autocompleteCustomer",
  emits: ['input', 'select', 'clear'], // 声明所有触发的事件
  props: {
    value: {
      type: String,
      default: ""
    },
    project_id: {
      type: Number|String,
      default: 0
    },
    class_tx: {
      type: Number|String,
      default: 0
    }
  },
  data() {
    return {
      // 定义内部变量，初始值同步 prop 的 value
      innerValue: this.value
    };
  },
  watch: {
    // 监听父组件传递的 value 变化，同步到内部变量
    value(newVal) {
      this.innerValue = newVal;
    },
    // 监听内部变量变化，同步触发 input 事件给父组件
    innerValue(newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    getKeyWords(queryString, cb) {
      // 简化 this 引用，避免 that 变量
      if (!queryString) {
        cb([]);
        return;
      }
      const where = {
        project_id: this.project_id,
        keywords: queryString,
        class_tx: 1
      };
      Http.post("/admin/Customer/getKeyWords", where, ret => {
        cb(ret.code ? ret.data : []);
      });
    },
    handleSelect(item) {
      if (item.id) {
        this.innerValue = item.name; // 修改内部变量
        this.$emit('select', item); // 触发选中事件
      }
    },
    clearData() {
      this.innerValue = ""; // 清空内部变量
      this.$emit('clear', {}); // 触发清空事件
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/common/autocompleteCustomer.vue